/* tslint:disable */
/* eslint-disable */
export enum ErrorCodes {
  FailedGettingOrderHistory = 'FAILED_GETTING_ORDER_HISTORY',
  FailedGettingOrder = 'FAILED_GETTING_ORDER',
  FailedGettingSettings = 'FAILED_GETTING_SETTINGS',
  FailedGettingTableSections = 'FAILED_GETTING_TABLE_SECTIONS',
  FailedCreatingOrder = 'FAILED_CREATING_ORDER',
  TrnFailedCreatingOrder = 'TRN_FAILED_CREATING_ORDER ',
  OrderDateIsPast = 'ORDER_DATE_IS_PAST',
  OrderDateIsIncorrect = 'ORDER_DATE_IS_INCORRECT',
  DeliveryZoneNotFound = 'DELIVERY_ZONE_NOT_FOUND',
  IncorrectNumberOfGuests = 'INCORRECT_NUMBER_OF_GUESTS',
  BasketNotFound = 'BASKET_NOT_FOUND',
  OrderNotFound = 'ORDER_NOT_FOUND',
  SettingsNotFound = 'SETTINGS_NOT_FOUND',
  WsmSettingsNotFound = 'WSM_SETTINGS_NOT_FOUND',
  StoreNotFound = 'STORE_NOT_FOUND',
  PromotionNotFound = 'PROMOTION_NOT_FOUND',
  AdditionalPageNotFound = 'ADDITIONAL_PAGE_NOT_FOUND',
  IncorrectPaymentType = 'INCORRECT_PAYMENT_TYPE',
  IncorrectDeliveryType = 'INCORRECT_DELIVERY_TYPE',
  IncorrectSiteMode = 'INCORRECT_SITE_MODE',
  EmptyCustomer = 'EMPTY_CUSTOMER',
  EmptyCustomerName = 'EMPTY_CUSTOMER_NAME',
  EmptyCustomerPhone = 'EMPTY_CUSTOMER_PHONE',
  EmptyCustomerEmail = 'EMPTY_CUSTOMER_EMAIL',
  TablesNotSpecified = 'TABLES_NOT_SPECIFIED',
  DeliveryTimeNotSpecified = 'DELIVERY_TIME_NOT_SPECIFIED',
  UnableToDetermineDeliveryCost = 'UNABLE_TO_DETERMINE_DELIVERY_COST',
  OrderAlreadyProcessed = 'ORDER_ALREADY_PROCESSED',
  UnableToCreatePaymentUrl = 'UNABLE_TO_CREATE_PAYMENT_URL',
  PaymentAlreadyProcessed = 'PAYMENT_ALREADY_PROCESSED',
  CommissionExceedsPayment = 'COMMISSION_EXCEEDS_PAYMENT',
  ItemNotFound = 'ITEM_NOT_FOUND',
  DeliveryAddressHintsQueryIsTooShort = 'DELIVERY_ADDRESS_HINTS_QUERY_IS_TOO_SHORT',
  AddressIsRequired = 'ADDRESS_IS_REQUIRED',
  CityStreetHouseAreRequired = 'CITY_STREET_HOUSE_ARE_REQUIRED',
  Line1IsRequired = 'LINE_1_IS_REQUIRED',
  MenuNotFound = 'MENU_NOT_FOUND',
  MenuCategoryIsNotOnSchedule = 'MENU_CATEGORY_IS_NOT_ON_SCHEDULE',
  WrongStatus = 'WRONG_STATUS',
  RequestContextNotInitialized = 'REQUEST_CONTEXT_NOT_INITIALIZED',
  NoCustomerProvider = 'NO_CUSTOMER_PROVIDER',
  CustomerNotRegistered = 'CUSTOMER_NOT_REGISTERED',
  CustomerAlreadyRegistered = 'CUSTOMER_ALREADY_REGISTERED',
  CustomerIsDeleted = 'CUSTOMER_IS_DELETED',
  FailedUpdateCustomer = 'FAILED_UPDATE_CUSTOMER',
  FailedRegisterCustomer = 'FAILED_REGISTER_CUSTOMER',
  TokenCanNotBeEmpty = 'TOKEN_CAN_NOT_BE_EMPTY',
  AuthNeeded = 'AUTH_NEEDED',
  FailedToFetchCustomerInfo = 'FAILED_TO_FETCH_CUSTOMER_INFO',
  FailedAuthCodeRequest = 'FAILED_AUTH_CODE_REQUEST',
  InvalidAuthCode = 'INVALID_AUTH_CODE',
  CustomerSessionNotFound = 'CUSTOMER_SESSION_NOT_FOUND',
  NoLoyaltyProvider = 'NO_LOYALTY_PROVIDER',
  FailedToCalculateCheckin = 'FAILED_TO_CALCULATE_CHECKIN',
  FailedProcessPersonalDocumentRequest = 'FAILED_PROCESS_PERSONAL_DOCUMENT_REQUEST',
  UnsupportedProvider = 'UNSUPPORTED_PROVIDER'
}
